// AI-CONTEXT: See docs/features/livereport-widgets-housevisits-personas.md
// Detect template-preview mode by URL flag. Centralised so the seven
// Housevisits/Personas widgets don't each redefine the same one-liner.

/**
 * @returns {boolean} true when the editor URL contains `?template=true`
 */
const isTemplateMode = () =>
    new URLSearchParams(window.location.search).get('template') === 'true'

export default isTemplateMode
